import angular from 'angular';
import { ConfiguracoesPortariaController } from './configuracoes-portaria.controller';

export class ConfiguracoesPortariaComponent implements angular.IComponentOptions {
    static selector = 'configuracoesPortariaComponent';
    static controller = ConfiguracoesPortariaController;
    static template = require('!!html-loader!./configuracoes-portaria.html');
}
